function Footer() {
    return (
        <>
      <footer>
        
        <div className="socialMedia">            
            <a className="smTiktok" href="https://www.tiktok.com/@rantcpu" title="Tiktok" target="_blank" rel="noreferrer">Tiktok</a>
            <a className="smTwitter" href="https://twitter.com/RantCPU" title="X / Twitter" target="_blank" rel="noreferrer">X / Twitter</a>
            <a className="smYoutube" href="https://www.youtube.com/@RantCPU/" title="Youtube" target="_blank" rel="noreferrer">Youtube</a>
        </div>
        <div className="legal">
            
            <a target="_blank" href="https://liith.org/rantcpusizzle/terms.html">Terms of service</a>
            <a target="_blank" href="https://liith.org/rantcpusizzle/FAQ.html">FAQ</a>
        </div>
        <div className="bottomFooter">
            <p>Copyright © 2023 Liithos. all rights reserved</p>
        </div>
    </footer>
        </>
    );
}

export default Footer;